import {SpellRangeDash} from "./SpellRangeDash";

export default SpellRangeDash;